import { InputEmail } from "@/components/Input/Email/InputEmail";
import { memo, useCallback } from "react";
import type { FieldRenderInputProps } from "../../types";
import { BaseField } from "./BaseField";
import type { BaseFieldProps } from "./BaseField";

interface EmailFieldProps extends BaseFieldProps {
  /**
   * プレースホルダー
   */
  placeholder?: string;
}

export const EmailField = memo(
  ({
    fieldId,
    field,
    layout,
    readOnly,
    disabled,
    className,
    "data-testid": testId,
  }: EmailFieldProps) => {
    // 入力レンダリング関数
    const renderInput = useCallback(
      (props: FieldRenderInputProps) => {
        // 入力値を文字列に変換
        const stringValue =
          props.value !== undefined ? String(props.value) : "";

        // 入力変更ハンドラー
        const handleChange = (value: string) => {
          props.onChange(value);
        };

        return (
          <InputEmail
            key={props.id}
            value={stringValue}
            onChange={handleChange}
            onBlur={props.onBlur}
            placeholder={props.placeholder}
            disabled={props.disabled}
            readOnly={props.readOnly}
            required={props.required}
            width={layout === "vertical" ? "full" : "auto"}
            aria-invalid={!!props.error}
            aria-describedby={props.error ? `${props.id}-error` : undefined}
          />
        );
      },
      [layout],
    );

    // BaseFieldを使用してEメールフィールドをレンダリング
    return (
      <BaseField
        fieldId={fieldId}
        field={field}
        readOnly={readOnly}
        disabled={disabled}
        layout={layout}
        className={className}
        data-testid={testId}
        renderInput={renderInput}
      />
    );
  },
);

EmailField.displayName = "EmailField";
